import React from "react";
import { Button, FormHelperText } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import AppForm from "components/Shared/AppForm";
import FileDropzone from "components/Shared/FileDropzone";
import { useAuth, useDOUploadFile } from "hooks";

const BranchTallyUploadAttachmentForm = ({ isBusy = false, onCancel, onSubmit }) => {
  const { viewEntity } = useAuth();
  const { handleUploadFiles, uploadingFiles } = useDOUploadFile();
  const { control, handleSubmit, setValue, formState: { errors } } = useForm({ defaultValues: { attachment: null } });

  const submit = async ({ attachment }) => {
    const { uploadedFiles } = await handleUploadFiles([attachment], {
      folderName: "BRANCH_TALLY_UPLOAD",
      entity: viewEntity?.entity?._id,
      account: viewEntity?.entity?.account?._id,
    });
    await onSubmit(uploadedFiles);
  };

  return (
    <AppForm loading={isBusy || uploadingFiles}>
      <AppForm.Content>
        <FormHelperText>Attachments</FormHelperText>
        <Controller name="attachment" control={control} rules={{ required: "Attachment is required." }} render={({ field }) => (
          <FileDropzone files={field.value ? [field.value] : []} onFileChange={(files) => setValue("attachment", files[0] || null, { shouldValidate: true })} error={!!errors.attachment} helperText={errors.attachment?.message} />
        )} />
      </AppForm.Content>
      <AppForm.Actions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit(submit)} disabled={isBusy || uploadingFiles}>Add</Button>
      </AppForm.Actions>
    </AppForm>
  );
};

export default BranchTallyUploadAttachmentForm;
